import React from "react";

export default function CloudIcon({ color = "#62bbe8", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 179 120"
      width={179}
      height={120}
      {...restProps}
    >
      <path
        fill={color}
        d="M230.343,136a55.452,55.452,0,0,0-103.868-14.88,45.042,45.042,0,0,0,4.82,89.724h96.4A37.447,37.447,0,1,0,230.343,136Zm-39.737,22.319v30.02H160.95v-30.02H138.874l37.088-37.5,36.978,37.5Z"
        transform="translate(-87.057 -90.868)"
      />
    </svg>
  );
}
